module.exports = __webpack_public_path__ + "static/media/Oriana Madrigal.2b6c6bc3.jpg";